/*
 * @ProjectName: vra
 * @FileName:
 * @PackageName:
 * @Author: Lv Zhuolin
 * @Date: 2021-03-22 11:10:00
 * @LastEditTime: 2021-01-11 13:56:52
 * @LastEditors: Lv Zhuolin
 * @Description:
 * @FilePath: /desktop/src/service/unionService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";
import languages from "../store/modules/languages";
import { getToken } from "@/utils/auth";
import Vue from 'vue'

/**
 * 工会人员列表
 */
export function getUnionMemberData(Info) {
  return request({
    url:
      "/api/v1/member/apply/list?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET"
  });
}
/*
 * 改变工会人员状态
 */
export function editUnionMemberStatus(data) {
  return request({
    url: "/api/v1/member/apply/" + data.id + "/audit",
    method: "PATCH",
    data: data.data
  });
}
/**
 * 下载Excel文件
 */
export function downloadUnionMemberData(data) {
  return request({
    url: "/api/v1/member/downloadExcel",
    method: "POST",
    responseType: "blob",
    data: data
  });
}

/**
 * 批量导入
 * @param {*} formdata 
 * @returns 
 */
export function asyncUploadUnionMember (formdata) {
  Vue.prototype.$axios.defaults.baseURL = process.env.BASE_API;
  let config = {
    headers: {
      'Authorization': 'Bearer' + ' ' + getToken(),
      'Accept-Language': languages.state.currentLang.value,
      'Content-Type': 'multipart/form-data'
    }
  };
  return Vue.prototype.$axios.post("/api/v1/member/excelImport", formdata, config)
}

/**
 * 工会会员管理列表
 */
 export function getUnionMemberManagementData(Info) {
  return request({
    url:
      "/api/v1/adopt/member/list?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET"
  });
}

/**
 * 下载会员管理Excel文件
 */
 export function downloadUnionMemberManagementData() {
  return request({
    url: "/api/v1/adopt/downloadExcel",
    method: "GET",
    responseType: "blob"
  });
}



// WEBPACK FOOTER //
// ./src/service/unionService.js